import { render } from "./CommissionsList.vue?vue&type=template&id=ea823e98&scoped=true"
import script from "./CommissionsList.vue?vue&type=script&lang=js"
export * from "./CommissionsList.vue?vue&type=script&lang=js"

import "./CommissionsList.vue?vue&type=style&index=0&id=ea823e98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea823e98"]])

export default __exports__